module.exports = __webpack_public_path__ + "static/media/family.7a2da640.svg";